import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.company.root]: {
    path: appPaths.company.root
  },
  [appPaths.company.topics]: {
    path: appPaths.company.topics
  },
  [appPaths.company.settings]: {
    path: appPaths.company.settings
  },
  [appPaths.company.featureRequests]: {
    path: appPaths.company.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.company.bugReports]: {
    path: appPaths.company.bugReports,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  }
};
